import { Routes, Route } from 'react-router-dom';
import DisplayMain from './pages/DisplayMain';

function DisplayApp() {
  return (
    <div className="min-h-screen">
      <Routes>
        <Route path="/" element={<DisplayMain />} />
        {/* Display will render different projection modes dynamically
            based on server-side state, not routing */}
      </Routes>
    </div>
  );
}

export default DisplayApp;
